module.exports = __webpack_public_path__ + "static/media/right-chevron.0e6a1d63.svg";